import { Validator } from "./validator";

const ITEM_CODE = {
  ORGANIZATION_ID: "00",
  NAME: "01",
  NOTE: "02",
  IMAGE_FILE: "03",
};

// 名称のデフォルト最大文字数
const MAX_NAME_LENGTH = 20;
const MAX_NOTE_LENGTH = 200;
const MAX_IMAGE_FILE_SIZE_MB = 3;
// const MAX_NAME_FILE_SIZE_MB = 2;

class MonitoringTargetsValidator extends Validator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this.errors.organizationId = [];
    this.errors.projectId = [];
    this.errors.monitoringTargetId = [];

    this.errors.name = [];
    this.errors.note = [];
    this.errors.imageFile = [];
  }
  /* eslint-enable */
}

class MonitoringTargetsStoreValidator extends MonitoringTargetsValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(monitoringTarget) {
    const validator = new MonitoringTargetsStoreValidator();

    // 組織ID
    validator.checkRequired(
      "organizationId",
      monitoringTarget.organizationId,
      "組織ID",
      ITEM_CODE.ORGANIZATION_ID,
    );

    // 管理名称
    validator.checkName(
      "name",
      monitoringTarget.name,
      "監視対象名",
      ITEM_CODE.NAME,
      {
        maxSize: MAX_NAME_LENGTH,
      },
    );

    // 備考欄
    validator.checkText(
      "note",
      monitoringTarget.note,
      "備考欄",
      ITEM_CODE.NOTE,
      {
        maxSize: MAX_NOTE_LENGTH,
        required: false,
      },
    );

    return validator;
  }
}

class MonitoringTargetsUpdateValidator extends MonitoringTargetsValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(monitoringTarget) {
    const validator = new MonitoringTargetsUpdateValidator();

    // 管理名称
    validator.checkName(
      "name",
      monitoringTarget.name,
      "監視対象名",
      ITEM_CODE.NAME,
      {
        maxSize: MAX_NAME_LENGTH,
      },
    );

    // 備考欄
    validator.checkText(
      "note",
      monitoringTarget.note,
      "備考欄",
      ITEM_CODE.NOTE,
      {
        maxSize: MAX_NOTE_LENGTH,
        required: false,
      },
    );

    return validator;
  }
}

class MonitoringTargetsImageUploadValidator extends MonitoringTargetsValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(uploadImageFile) {
    const validator = new MonitoringTargetsImageUploadValidator();
    // 管理名称
    validator.checkFileSize(
      "imageFile",
      uploadImageFile,
      "表示画像",
      ITEM_CODE.IMAGE_FILE,
      {
        maxFileSizeMb: MAX_IMAGE_FILE_SIZE_MB,
      },
    );

    // 管理名称
    validator.checkFileExt(
      "imageFile",
      uploadImageFile,
      [
        "png",
        "jpg",
        "jpeg",
      ],
      "表示画像",
      ITEM_CODE.IMAGE_FILE,
    );

    return validator;
  }
}

export {
  MonitoringTargetsValidator,
  MonitoringTargetsStoreValidator,
  MonitoringTargetsUpdateValidator,
  MonitoringTargetsImageUploadValidator,
};
